import styles from './cyclist.module.css';
import MediumHero from './hero/mediumHero';
import Vision from './vision/vision';
import CTA from './cta/cta';
import { Link } from 'react-router-dom';

const Pages = () => {
    return (
        <div className={styles.pagesContainer}>
            <MediumHero 
                imageUrl="https://images.unsplash.com/photo-1616963248328-6b7bea589840" 
                altText="Súkklumynd"
            />
            <h1>Til súkklarar</h1>
            <p>Súkklufelagið arbeiðir fyri tínum umstøðum at trygt ferðast runt í Havnini á súkklu, til gongu ella aðrar ábærar mátar.</p>
            <Vision />
            <p>Fyri at at eydnast í hesum, er tað av stórum týdningi, at vit øll taka lut í átøkum og undirskriftainnsavningum..</p>
            
            <CTA
                text="Tekur tú undir við okkara arbeiði og hugsjón, heita vit á teg um at:"
                CTA={[ 
                    <>vísa okkum undirtøku á <Link to="/limir">hesari leinkjuni</Link></>,
                    "Skriva undir tá vit hava undirskriftainnsavningar"
                ]}
            />
        </div>
    );
};

export default Pages;
